import { combineReducers } from 'redux'

import deleteNode from './products/delete'
import get from './products/get'
import list from './products/list'
import post from './products/post'
import put from './products/put'
import reorder from './products/reorder'
import view from './products/view'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put,
  reorder,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/products.js